import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Dropdown } from 'semantic-ui-react';
import { numnowrap } from '../../../utils';
import * as API from '../../API';
import './KbKostraGroupSelector.scss';
export const KbKostraGroupSelector = ({ className, prompt, enabled = true }) => {
    var _a, _b, _c;
    const dropdownRef = useRef(null);
    useEffect(() => {
        var _a;
        const dropdownList = (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.menu');
        if (!dropdownList) {
            return;
        }
        // Prevents unwanted page scroll when wheel-selecting dropdown item
        const onWheel = (e) => {
            const isScrollingUp = e.deltaY < 0;
            const isScrollingDown = e.deltaY > 0;
            const scrollTop = dropdownList.scrollTop;
            const scrollHeight = dropdownList.scrollHeight;
            const clientHeight = dropdownList.clientHeight;
            const hit = {
                get top() { return (isScrollingUp && scrollTop <= 0); },
                get bottom() { return (isScrollingDown && (scrollTop + clientHeight >= scrollHeight)); }
            };
            if (hit.top || hit.bottom) {
                e.preventDefault();
            }
        };
        dropdownList.addEventListener('wheel', onWheel, { passive: false });
        return () => {
            dropdownList.removeEventListener('wheel', onWheel);
        };
    }, []);
    const clsx = [
        'kb-selector',
        'kb-kostra-group-selector',
        className !== null && className !== void 0 ? className : '',
        enabled ? 'enabled' : 'disabled'
    ].join(' ');
    const { data: codeListData } = useQuery('kb/kodeliste', API.fetchCodeList);
    const hashParts = window.location.hash.split('?');
    const searchParams = new URLSearchParams((_a = hashParts[1]) !== null && _a !== void 0 ? _a : '?');
    const currentSelection = (_b = searchParams.get('kostragruppe')) !== null && _b !== void 0 ? _b : '';
    const addSoftHyphens = (str) => {
        const phrases = [
            ['konsesjonskraftinntekter', 'konsesjons\u00ADkraft\u00ADinntekter'],
            ['skatteinntektene', 'skatte\u00ADinntektene'],
            ['eiendomsskatt', 'eiendoms\u00ADskatt'],
            ['kommunal', 'kom\u00ADmunal']
        ];
        let newStr = str;
        phrases.forEach((pair) => {
            newStr = newStr.replace(pair[0], pair[1]);
        });
        return newStr;
    };
    let opts = [];
    opts.push(_jsx(Dropdown.Header, { children: "Kostragrupper" }, "hdr"));
    opts = opts.concat(Object.entries((_c = codeListData === null || codeListData === void 0 ? void 0 : codeListData.kostragrupper) !== null && _c !== void 0 ? _c : {}).map(([code, description]) => ({
        key: code,
        value: code,
        text: _jsxs("span", { className: "kostragroup", children: [_jsxs("strong", { children: [code, ":"] }), " ", addSoftHyphens(numnowrap(description))] })
    })));
    const onSelectFilter = (e, data) => {
        if (data.value === '') {
            searchParams.delete('kostragruppe');
        }
        else {
            searchParams.set('kostragruppe', data.value);
            searchParams.set('noscroll', '1');
        }
        const q = searchParams.toString();
        window.location.hash = hashParts[0] + (q ? `?${q}` : ``);
    };
    const onClick = (e) => {
    };
    return (_jsx("div", { className: `${clsx}`, tabIndex: -1, title: enabled ? '' : 'Krever abonnement', children: _jsx(Dropdown, { ref: dropdownRef, placeholder: prompt !== null && prompt !== void 0 ? prompt : "Velg kostragruppe", fluid: true, selection: true, disabled: !enabled, clearable: true, value: currentSelection, options: opts, onChange: onSelectFilter, onClick: onClick }) }));
};
